import { Qualifier } from "../../../../../../domain/entities/product/Features";

const QUALIFIER_PERCENTAGE_ID = "percentage";

const shouldDisplayPercentages = (qualifier: Qualifier | undefined): boolean => {
  if (!qualifier) return false;
  const { qualifierValues, name } = qualifier;
  if (!qualifierValues || name !== QUALIFIER_PERCENTAGE_ID) return false;

  return true;
};

export { shouldDisplayPercentages };
